import { Component } from '@angular/core';
import { TranslocoModule } from "@ngneat/transloco";
import {
  SearchBarInterceptorComponent
} from "../../../../../widgets/search-bar-interceptor/search-bar-interceptor.component";

@Component({
    selector: 'app-header-pal',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    imports: [
        TranslocoModule,
        SearchBarInterceptorComponent,
    ]
})
export class HeaderComponent {

}
